/* import __COLOCATED_TEMPLATE__ from './phone-number.hbs'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PhoneFormatter, TextField } from 'field-kit';
let PhoneNumber = (_class = class PhoneNumber extends Component {
  async initializeFieldKit(marketInputTextElement) {
    const inputElement = await marketInputTextElement.getInputElement();
    const formatter = new PhoneFormatter();
    if (this.args.initialValue) {
      // eslint-disable-next-line require-atomic-updates
      marketInputTextElement.value = formatter.format(this.args.initialValue);
    }
    const fieldKit = new TextField(inputElement, formatter);
    const textDidChange = field => {
      this.args.onValueChange(field.value());
    };
    fieldKit.setDelegate({
      textDidChange
    });
  }
}, (_applyDecoratedDescriptor(_class.prototype, "initializeFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFieldKit"), _class.prototype)), _class);
export { PhoneNumber as default };